var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var abi = require('../abi/IRelayRecipient.json');

var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
var SAMPLE_DATA = '0x9bd9bbc600000000000000000000000095065dda67b45188a131674ad9dc0bf075238de2000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000600000000000000000000000000000000000000000000000000000000000000000';

module.exports =
/*#__PURE__*/
function () {
  var _canRelay = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(web3, contractAddress, fromAddress) {
    var contract, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contract = new web3.eth.Contract(abi, contractAddress);
            _context.prev = 1;
            _context.next = 4;
            return contract.methods.acceptRelayedCall(ZERO_ADDRESS, fromAddress, SAMPLE_DATA, '0', '0', '0x0', '0x0').call();

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response.eq(0));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  function canRelay(_x, _x2, _x3) {
    return _canRelay.apply(this, arguments);
  }

  return canRelay;
}();